import { render, staticRenderFns } from "./ModalAddCategory.vue?vue&type=template&id=afe88322&scoped=true"
import script from "./ModalAddCategory.vue?vue&type=script&lang=js"
export * from "./ModalAddCategory.vue?vue&type=script&lang=js"
import style0 from "./ModalAddCategory.vue?vue&type=style&index=0&id=afe88322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe88322",
  null
  
)

export default component.exports